export default {
	root: {
		paddingBottom: 40
	}
};
